/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CustomPlan/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import MaxLength from './MaxLength/index'
import MinDownpayment from './MinDownpayment/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CustomPlan({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/CustomPlan"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="CustomPlan.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-tIzKw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-2-tIzKw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-tIzKw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-tIzKw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<MinDownpayment
  viewPath={`${viewPath}/MinDownpayment`}
/>
<MaxLength
  viewPath={`${viewPath}/MaxLength`}
/>
</div>
{children}
</React.Fragment>)
}